import React from 'react'
import ImageGallery from "../ImageGallery/ImageGallery";

const SectionFour = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, setMessageBoard, setErrorTabEnable } = props
    return (
        <>
            <div className="error-message-head1">Check the issue status</div>
            <div className="error-message-head2">
                Check if the issue is resolved
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        handleButtonClick(4, "yes");
                        setMessageBoard(false);
                        setErrorTabEnable(false);
                    }}
                    className={`error-button ${toggleOption[4] === "yes" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[4]}
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        handleButtonClick(4, "no");
                        setSelectedOptions([true, true, true, true, true, false, false]);
                    }}
                    className={`error-button ${toggleOption[4] === "no" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[4]}
                >
                    No
                </button>
            </div>
            <div className="error-message-head2">
                Request subscriber to perform reconnection procedure (switch off power
                supply, wait for 10 seconds and then switch on the power supply)
            </div>
            <ImageGallery />
            <div className="error-message-head1">Call Logs</div>
        </>
    )
}

export default SectionFour
